import cx from 'classnames';
import { useIntl, defineMessages } from 'react-intl';

import config from '@plone/registry';

import styles from '@redturtle/qubicaamf-theme/components/Blocks/Listing/DiveInTheSector/styles.module.css';
import Slides from '@redturtle/qubicaamf-theme/components/Blocks/Listing/DiveInTheSector/Slides';

const DiveInTheSector = (props) => {
  const intl = useIntl();
  const Container = config.getComponent('Container').component || 'div';

  const slides = props.items.map((item) => {
    return {
      '@id': item['@id'],
      title: item.title,
      image: item,
      link: item,
    };
  });
  return (
    <Container
      className={cx('block-dits-container', styles.blockDitsContainer, {
        'has--fullwidth--true': props?.styles?.fullwidth,
      })}
    >
      {props?.items?.length > 0 ? (
        <Slides slides={slides} editMode={props.isEditMode} />
      ) : (
        <div>{intl.formatMessage(messages.help_text)}</div>
      )}
    </Container>
  );
};

export default DiveInTheSector;

const messages = defineMessages({
  help_text: {
    id: 'help_text',
    defaultMessage: 'Add slides from the sidebar',
  },
});
